window.addEventListener("scroll", () => {
  const scrollY = window.scrollY;

  // Select all elements with rgb-white, rgb-low, or rgb-high
  const elements = document.querySelectorAll(".rgb-white, .rgb-low, .rgb-high");

  elements.forEach((el) => {
    // Shift the gradient horizontally based on scroll
    el.style.backgroundPositionX = `${scrollY * 0.5}px`;
  });
});
